import './BillingInfo.less';
import { Card, Col, notification, Row, Tabs } from 'antd';
import React, { useEffect } from 'react';
import LoadingIndicator from '../../components/shared/LoadingIndicator/LoadingIndicator';
import { useFetchBillingInfoQuery } from '../service';
import BillingInfoForm from './BillingInfoForm';
import useGetSubscription from '../hooks/useGetSubscription';
import SubscriptionPlansHeader from '../subscription/SubscriptionPlansHeader';
import InvoiceHistory from '../InvoiceHistory';
import UpdatePaymentMethod from './UpdatePaymentMethod';

const { TabPane } = Tabs;

export default function BillingInfo() {
    const { data: billingInfo, isLoading: isLoadingBillingInfo, isError } = useFetchBillingInfoQuery();
    const { userSubscription, isInFreeTrial, isLoading: isLoadingSubscription } = useGetSubscription();

    useEffect(() => {
        if (!isLoadingBillingInfo && isError) {
            notification.error({ message: 'Error', description: 'Cannot fetch billing information. Please try again or contact support!' });
        }
    }, [isError, isLoadingBillingInfo]);

    const isLoading = isLoadingBillingInfo || isLoadingSubscription;

    return (
        <div>
            <Card bordered={false}>
                <Tabs
                    className="billing-info-tabs"
                    type="card"
                >
                    <TabPane
                        tab="Billing info"
                        key="billing-info"
                    >
                        {isLoading && <LoadingIndicator />}
                        {!isLoading && billingInfo && (
                            <Row gutter={24}>
                                <Col
                                    sm={24}
                                    lg={12}
                                    xl={12}
                                >
                                    <BillingInfoForm
                                        firstName={billingInfo.first_name}
                                        lastName={billingInfo.last_name}
                                        company={billingInfo.company}
                                        vatNumber={billingInfo.vat_number}
                                    />
                                </Col>
                                <Col
                                    sm={24}
                                    lg={12}
                                    xl={12}
                                >
                                    <div className="pricing-meta">
                                        {userSubscription && (
                                            <SubscriptionPlansHeader
                                                subscriptionStatus={userSubscription.status}
                                                planName={userSubscription.plan_details.name}
                                                planPrice={userSubscription.plan_details.price}
                                                planIntervalUnit={userSubscription.plan_details.interval_unit}
                                                planIntervalLength={userSubscription.plan_details.interval_length}
                                                currentPeriodEnd={userSubscription.current_period_ends_at}
                                                isInFreeTrial={isInFreeTrial}
                                            />
                                        )}

                                        <InvoiceHistory />
                                    </div>
                                </Col>
                            </Row>
                        )}
                    </TabPane>

                    <TabPane
                        tab="Payment method"
                        key="payment-method"
                    >
                        {isLoading && <LoadingIndicator />}
                        {!isLoading && billingInfo && (
                            <UpdatePaymentMethod
                                cardType={billingInfo.card_type}
                                lastFour={billingInfo.last_four}
                                paypalBillingAgreementId={billingInfo.paypal_billing_agreement_id}
                            />
                        )}
                    </TabPane>
                </Tabs>
            </Card>
        </div>
    );
}
